/**
 * Copyright © 2026 Adnuntius AS.
 */
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';

/**
 * Close the copy modal, then emit the result on the next macrotask.
 *
 * Emitting synchronously from $save().then (before or with hide) races modal
 * teardown and destination-route CD, which surfaces as NG0100 on edit pages
 * (e.g. hasValidationWarnings flipping during the first check).
 */
export function completeCopyModal<T>(bsModalRef: BsModalRef, onCopied: Subject<T>, result: T): void {
  bsModalRef.hide();
  setTimeout(() => onCopied.next(result));
}
